export default class SwingerWidget {

  constructor(el) {
    if (!el.attachShadow) {
      return;
    }

    this.el = el;
    this.type = this.el.getAttribute('data-swinger-widget');
    this.shadowRoot = this.el.attachShadow({mode: 'open'});

    [
      'submit',
      'reset',
      'change',
      'animationstart',
      'animationend'
    ].forEach((eventName) => {
      this.shadowRoot.addEventListener(eventName, (e) => {
        const target = e.target;

        e.preventDefault();
        e.stopImmediatePropagation();

        const event = new Event(`swinger:artificial:${eventName}`, {
          bubbles: true,
          composed: true
        });

        target.dispatchEvent(event);
      }, true);
    });

    try {
      this.loadStylesheet(`/resources/skins/${window.swinger.config.client}/main.css?v=${window.swinger.config.version}`, () => {
        const widget = document.createElement('span');

        widget.classList.add('swinger-widget');
        widget.classList.add('swinger-widget--dynamic');
        widget.classList.add(`swinger-widget--${this.type}`);
        widget.setAttribute('data-type', this.type);
        widget.setAttribute('data-component', this.type);

        this.shadowRoot.appendChild(widget);
      });
    } catch (e) {
      window.console.error('Fetching Swinger resources failed:', e);
    }
  }

  loadStylesheet(url, callback) {
    const stylesheet = document.createElement('link');

    if (callback) {
      stylesheet.onload = callback;
    }
    stylesheet.rel = 'stylesheet';
    stylesheet.href = url;

    this.shadowRoot.appendChild(stylesheet);
  }
}
